export default "__VITE_ASSET__c01d28e9__"